import { baseRoute } from '../../constants/routes';
export const TENANT_STATISTICS_ROUTE = baseRoute + '/unique-statistics/tenant';
export const GET_TENANT_STATISTICS = 'GET_TENANT_STATISTICS';
export const CLEAR_TENANT_STATISTICS = 'CLEAR_TENANT_STATISTICS';
export const CLEAR_TENANT_STATISTICS_SUCCESS = 'CLEAR_TENANT_STATISTICS_SUCCESS';
export const GET_TENANT_STATISTICS_SUCCESS = 'GET_TENANT_STATISTICS_SUCCESS';
